import { NgClass } from '@angular/common';
import { Component, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CustomCellParams } from '../../../models/custom-cell.params';

@Component({
  selector: 'grid-engine-outgoing-connector-cell',
  templateUrl: './outgoing-connector-cell.component.html',
  imports: [FlexLayoutModule, NgClass],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./outgoing-connector-cell.component.scss']
})
export class OutgoingConnectorCellComponent implements ICellRendererAngularComp {
  params: WritableSignal<CustomCellParams> = signal(null);

  agInit(params: CustomCellParams): void {
    this.params.set(params);
  }

  refresh(): boolean {
    return false;
  }
}
